import fp from 'lodash/fp';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Image from '../../components/Image/Image';

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: ${props => (props.lead ? '30px' : '18px')};
  justify-content: ${props => (props.lead ? 'center' : 'flex-start')};
  ${props =>
    props.lead &&
    css`
      margin-bottom: 24px;
      line-height: 1.2;
    `};
`;

const Avatar = styled(Image)`
  display: block;
  margin-right: ${props => (props.lead ? '17px' : '10px')};
  border-radius: 50%;
`;

class Profile extends PureComponent {
  static propTypes = {
    companyName: PropTypes.string,
    companyPhotoUrl: PropTypes.string,
    lead: PropTypes.bool
  };

  static defaultProps = {
    companyName: '',
    companyPhotoUrl: '',
    lead: false
  };

  get avatarSize() {
    return this.props.lead ? 60 : 30;
  }

  render() {
    const { companyPhotoUrl, companyName, lead } = this.props;

    return (
      <Container lead={lead}>
        {fp.size(companyPhotoUrl) > 0 && (
          <Avatar lead={lead} src={companyPhotoUrl} size={this.avatarSize} />
        )}
        {companyName}
      </Container>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/Login/Profile.js